module.exports = __webpack_public_path__ + "img/pro_six_2.c245c3d9.jpg";